import { PageHeader, Show } from '@/components';
import { useCreateBreadCrumbs } from '@/hooks';

import { useTranslation } from 'react-i18next';
import Loyalty from '../loyalty/loyalty';
import { useState } from 'react';
import { Tabs } from '@/uiComponents/common';
import MembershipForm from '../memberships/components/memberShipForm';

const CommissionScheme = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('PROGRAM');

  const tabs = [
    { isActive: activeTab === 'PROGRAM', title: t('generic.program'), type: 'PROGRAM' },
    { isActive: activeTab === 'CONCIERGE', title: t('generic.concierges'), type: 'CONCIERGE' },
    {
      isActive: activeTab === 'INDEPENDENT',
      title: t('generic.independents'),
      type: 'INDEPENDENT',
    },
    {
      isActive: activeTab === 'INTERNAL_STAFF',
      title: t('generic.collaborators'),
      type: 'INTERNAL_STAFF',
    },
  ];

  const handleTabs = (type) => {
    setActiveTab(type);
  };

  useCreateBreadCrumbs([
    { name: t('screens.configurations.title'), path: '/settings' },
    { name: t('screens.configurations.entityConfig.company.cards.scheme.title') },
  ]);

  return (
    <>
      <PageHeader
        border={false}
        title={t('screens.configurations.entityConfig.company.cards.scheme.title')}
      />
      <Tabs options={tabs} onClick={handleTabs} className='mb-3' />
      <Show>
        <Show.When isTrue={activeTab === 'PROGRAM'}>
          <MembershipForm />
        </Show.When>
        <Show.Else>
          <Loyalty mode={activeTab} />
        </Show.Else>
      </Show>
    </>
  );
};

export default CommissionScheme;
